import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("es_token");
  const master = sessionStorage.getItem("es_master_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  if (master) config.headers["X-Master-Token"] = master;
  return config;
});

export function apiError(detail) {
  if (detail == null) return "Ocorreu um erro. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export const errMsg = (e) => apiError(e?.response?.data?.detail) || e.message;
